import { styled } from '@linaria/react';
import { Button } from '@daedalus/atlas/Button';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
export const IMAGE_HEIGHT = 188;
const _exp = /*#__PURE__*/() => SkeletonLoader;
export const StyledSkeletonLoader = /*#__PURE__*/styled(_exp())({
  name: "StyledSkeletonLoader",
  class: "sh5gl38",
  propsAsIs: true
});
export const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1mfbh8m",
  propsAsIs: false
});
export const Grid = /*#__PURE__*/styled('div')({
  name: "Grid",
  class: "g1tv3m2s",
  propsAsIs: false
});
export const GridItem = /*#__PURE__*/styled('div')({
  name: "GridItem",
  class: "g1mqhmqj",
  propsAsIs: false
});
const _exp8 = /*#__PURE__*/() => Button;
export const AllPhotosButton = /*#__PURE__*/styled(_exp8())({
  name: "AllPhotosButton",
  class: "a1obo19j",
  propsAsIs: true
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");